import './App.css';
import './ui/palette.css';

import { DevMode } from './contexts';
import Landing from './landing/landing';
import MainApp from './app/MainApp';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { UserContext } from './app/contexts';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { NotFound } from './errors';


export default function LearnXSApp() {
  const [userData, setUserData] = useState(USERDATA);
  const devMode = initialState.devMode;


  const userErr = userData.error;

  useEffect(() => {
    let ignore = false;

    if (devMode) {
      setUserData(userDevData);

    } else {
      userErr &&
        fetch("/api/user")
          .then(res => res.json())
          .then(!ignore && setUserData)
          .catch(console.error)

    }

    return () => {
      ignore = true;
    };
  }, [devMode, userErr]);


  return (
    <DevMode.Provider value={devMode}>
      <UserContext.Provider value={userData} >
        <Router>
          <Routes>
            <Route path='/*' element={<Landing />}></Route>
            <Route path='/app/*' element={<MainApp />}></Route>
            <Route path='*' element={<NotFound />}></Route>
          </Routes>
        </Router>
      </UserContext.Provider>
    </DevMode.Provider>
  );

}

const Location = window.location, path = Location.pathname;


export const initialState = {
  view: path.slice(1),
  showSignIn: ["/login", "/register"].includes(path) && path.slice(1),
  devMode: true,
}

export const Host = 'https://andrew101.pythonanywhere.com';


export function Loading() {

  return (
    <div className="flex-col abs-mid">
      <i className="fa-solid fa-spinner fa-spin fa-2xl"></i>
      <div className="margin"> Loading ... </div>
    </div>
  )
}



export const Input = forwardRef((props, ref) => {
  const { autoFocus, className, label, id, required, type, spacing } = props;

  return (
    <div className={"form-floating " + (spacing ?? 'mb-3')}>
      <input {...{ autoFocus, id, required, type, placeholder: label }} className={`form-control${className ? (' ' + className) : ''}`} ref={ref}></input>
      <label htmlFor={id}> {label} </label>
    </div>
  )
})

export const TextArea = forwardRef((props, ref) => {
  const { autoFocus, className, label, id, required, type, spacing } = props;

  return (
    <div className={"form-floating " + (spacing ?? 'mb-3')}>
      <textarea {...{ autoFocus, id, required, type, placeholder: label }} className={`form-control${className ? (' ' + className) : ''}`} ></textarea>
      <label htmlFor={id}> {label} </label>
    </div>
  )
})


const USERDATA = await fetch("/users/me")
  .then(res => res.json())
  .then(json => json)
  .catch(err => {
    console.error(err)
    return { error: true }
  })

const userDevData = {
  first_name: "David",
  last_name: "Uwagbale",
  email: "duwagbale07@gmail.com"
}